import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import getConfig from 'next/config';
import { FC, PropsWithChildren, useRef } from 'react';
import { useIsMobile } from 'src/hooks/helpers/useIsMobile';

const { publicRuntimeConfig } = getConfig();

type Props = PropsWithChildren<
  | {
      mode: 'payment';
      savePaymentMethod?: boolean;
      amount?: number;
      sellerId?: string;
    }
  | {
      mode: 'setup';
      savePaymentMethod?: never;
      amount?: never;
      sellerId?: never;
    }
>;

// StripeのPaymentElementに充てるスタイルは同様だろうということで共通化している
export const ReserveStripeElements: FC<Props> = ({
  mode = 'payment',
  savePaymentMethod,
  amount,
  sellerId,
  children,
}) => {
  const stripePromise = useRef(loadStripe(publicRuntimeConfig.stripePublicKey));
  const isMobile = useIsMobile();

  return (
    <Elements
      stripe={stripePromise.current}
      options={{
        mode,
        // NOTE: このamountは表示用の値であり、apple payなどでのみ使われ、カード決済では表示されない
        // そのため実際の決済価格に影響する値では無いのだが、価格が0の場合は決済自体発生しないという問題があり
        // 適当な値を必ず設定するようにしている
        amount: mode === 'payment' ? Math.max(amount ?? 1, 1) : undefined,
        currency: 'jpy',
        paymentMethodCreation: 'manual',
        appearance: {
          theme: 'flat',
          variables: {
            colorPrimary: '#0066FF',
            colorBackground: '#ffffff',
            colorText: '#1B1B1B',
            colorDanger: '#CD0000',
            borderRadius: '15px',
            colorTextPlaceholder: '#878787',
            fontSizeSm: isMobile ? '13px' : '12px',
            fontSizeBase: isMobile ? '16px' : '15px',
            fontSizeLg: isMobile ? '24px' : '20px',
            fontSizeXl: isMobile ? '32px' : '28px',
          },
          rules: {
            '.Input': {
              border: '1px solid #E9E9E9',
            },
            '.Input--invalid': {
              backgroundColor: '#FFF2F2',
            },
          },
        },
        setupFutureUsage: savePaymentMethod ? 'off_session' : undefined,
        capture_method: 'manual',
        onBehalfOf: sellerId,
      }}
    >
      {children}
    </Elements>
  );
};
